module.exports = {"CS21":"银行","CS23":"房地产","CS18":"医药","CS04":"电力及公用事业","CS10":"机械","CS30":"综合","CS07":"建筑","CS08":"建材","CS16":"家电","CS20":"农林牧渔","CS26":"电子","CS14":"商贸零售","CS13":"汽车","CS27":"通信","CS28":"计算机","CS29":"传媒","CS01":"石油石化","CS03":"有色金属","CS25":"交通运输","CS22":"非银行金融","CS11":"电力设备及新能源","CS06":"基础化工","CS15":"消费者服务","CS09":"轻工制造","CS12":"国防军工","CS02":"煤炭","CS24":"综合金融","CS19":"食品饮料","CS05":"钢铁","CS17":"纺织服装"}


//////////////////
// WEBPACK FOOTER
// ./static/json/citic_code.json
// module id = ENcK
// module chunks = 3